module.exports = "/_next/static/images/call-center-6b48f23122a828d2f134576eea8535f5.jpg";